import React, { useEffect } from 'react'
import BaseModal from './BaseModal'
import { Container, Modal } from 'react-bootstrap'
import racerM from 'assets/images/eventBoatRacing/imgBoatFinish.png'
import racingFlag from 'assets/images/eventBoatRacing/imgRacingFlag.png'
import { mediaQueryPoint, useMediaQuery } from 'utils/hooks'
import { useTranslation } from 'react-i18next'

function FinishPopupModal({ show, onHide, data, ...otherProps }) {
  const {t} = useTranslation();

  useEffect(() => {
    let timeoutId;
    if (show) {
      timeoutId = setTimeout(() => {
        onHide()
      }, 3000)
    }

    return () => {
      clearTimeout(timeoutId)
    }
  }, [show])

  return (
		<BaseModal show={show} onHide={onHide} hideDecor={true} congrats {...otherProps}>
				<Modal.Body className="py-0 mt-2">
					<div className="d-flex justify-content-center">
						<img src={racerM} alt="Racer" width={243} height={142}/>
						<img src={racingFlag} alt="Let's go" width={200} height={142}/>
					</div>

					<div className="d-flex justify-content-center popup-content">
						<p className="text-center popup-content-text black finish-popup mt-2 pt-4 pb-2">
              {t('event.boat_racing.popup.reward.finish')}
            </p>
					</div>
				</Modal.Body>
		</BaseModal>
	)
}

export default FinishPopupModal
